import React from "react";

const TranslationCert = () => {
  return (
    <div className="transHeadContent">
      <h2>
        Certified <span>Translation</span> Services{" "}
      </h2>
      <p>
        Certified translations are often required for legal or legislative
        purposes. These translations include a stamp and signature, certifying
        their accuracy. A certified translator, appointed by a notary, is a
        recognized professional who has mastered translation skills through a
        program offered by an accredited college or institution.
      </p>
    </div>
  );
};

export default TranslationCert;
